const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-zimark-blue"></div>
    </div>
  )
}

export default LoadingSpinner
